import fs from 'fs';
import path from 'path';

import chalk from 'chalk';

import { pruneText } from 'semtree';

import { MD } from '../util/const';
import { getConfig } from '../util/config';
import type { InitTree } from '../util/tree';
import { getIndexFileUris, resetGlobCache } from '../util/util';


export function prune(node: string, payload: InitTree, argv?: any): void {
  const dryRun: boolean = !!(argv?.dryRun ?? argv?.['dry-run']);
  const single: boolean = !!(argv?.single || argv?.nodeOnly);
  const cfg: any = getConfig(payload.configUri);
  const indentWidth: number = cfg?.format?.indent_size ?? 2;
  const notePath: string = path.join(process.cwd(), node + MD);
  if (!fs.existsSync(notePath)) {
    console.error(chalk.red(`no such file: ${node}${MD}`));
    return;
  }
  const uris: string[] | undefined = getIndexFileUris(payload.doctypeUri, payload.globIndexUris);
  if (!uris || uris.length === 0) {
    console.error(chalk.red('no index files found'));
    return;
  }
  const cwd: string = process.cwd();
  for (const uri of uris) {
    const content: string = fs.readFileSync(uri, 'utf8');
    const next: string | null = pruneText(content, node, single, indentWidth);
    if (next === null) {
      continue;
    }
    const indexRelPath: string = path.relative(cwd, uri) || path.basename(uri);
    if (dryRun) {
      console.log(formatDryRun(node, single, indexRelPath));
      return;
    }
    if (next !== content) {
      fs.writeFileSync(uri, next, 'utf8');
    }
    resetGlobCache();
    console.log(formatSuccess(node, single));
    return;
  }
  console.error(formatError(node));
}

// format

function formatMode(single: boolean): string {
  return single ? 'single bullet' : 'subtree';
}

function formatDryRun(node: string, single: boolean, indexRelPath: string): string {
  return chalk.cyan(`[dry-run] would prune [[${node}]] (${formatMode(single)}) in ${indexRelPath} (no changes written)`);
}

function formatSuccess(node: string, single: boolean): string {
  return `pruned [[${node}]] (${formatMode(single)})`;
}

function formatError(node: string): string {
  return chalk.red(`could not prune [[${node}]] (not found in index)`);
}
